import {HostListener, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs/Rx';
import {BikeRack, Pet, Vehicle, Locker, ParkingSpot, Resident, Unit, Vendor} from '../../../types/data.types';
import {DirectoryService} from '../../../services/directory.service';
import {UrlService} from '../../../services/url.service';
import {EmptyRowService} from '../../../services/empty-row.service';
import {IResidentPatch} from '../../../types/api-response/building/resident-patch';

declare const $: any;

export class AbstractListComponent implements OnInit, OnDestroy {
    s: Array<Subscription> = [];
    data: Array<Resident|Unit|ParkingSpot|Locker|Vehicle|Pet|BikeRack|Vendor|IResidentPatch> = [];

    constructor(
        public directoryService: DirectoryService,
        public urlService: UrlService,
        public emptyRowService: EmptyRowService,
    ) {}

    ngOnInit() {
        this.s.push(this.directoryService.onToggleDetailedView.subscribe(
            (data) => { if (!data) this.uncheckItem(); })
        );
    }

    ngOnDestroy(): void {
        this.s.forEach((subscription: Subscription) => subscription.unsubscribe());
    }

    toggleCheck(selectedItem): void {
        const checked = selectedItem.checked;
        this.uncheckItem();
        if (checked) {
            this.directoryService.toggleDetailedView(null, false);
            if (this.directoryService.currentTabId === 'residents') {
                this.directoryService.selectedResidentInstructions = [];
                this.directoryService.instructionsObservable.unsubscribe();
            }
        } else {
            selectedItem.checked = true;
            this.directoryService.toggleDetailedView(selectedItem, true);
            if (this.directoryService.currentTabId === 'residents') {
                this.directoryService.getResidentInstructions(selectedItem.id);
            }
        }
    }

    uncheckItem(): void {
        this.data.forEach((item: any) => item.checked = false);
    }

    orderBy(orderBy: string, $event) {
        if (this.data.length < 2) return;
        this.urlService.orderBy(orderBy, $event);
    }

    fillEmptyRow() {
        this.emptyRowService.fillEmptyRow();
    }

    showHint(e) {
        e.stopPropagation();
        const $td = $(e.target).closest('.table-hint-td');
        if ($td.hasClass('active'))
            $td.removeClass('active');
        else {
            $('.table-hint-td').removeClass('active');
            $td.addClass('active');
        }
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.fillEmptyRow();
    }

}



// WEBPACK FOOTER //
// /app/src/app/components/directory/list/abstract-list.component.ts